import { render, staticRenderFns } from "./HomeSelectPaymentSystem.vue?vue&type=template&id=306b3322&"
import script from "./HomeSelectPaymentSystem.vue?vue&type=script&lang=ts&"
export * from "./HomeSelectPaymentSystem.vue?vue&type=script&lang=ts&"
import style0 from "./HomeSelectPaymentSystem.vue?vue&type=style&index=0&id=306b3322&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QImg});
